import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.501 7.442a.75.75 0 0 1 .057 1.06l-7.188 8a.75.75 0 0 1-1.115 0L6.442 13.37a.75.75 0 0 1 1.116-1.003l2.255 2.51 6.63-7.38a.75.75 0 0 1 1.058-.056",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgComponent);
export const CheckMiniIcon = ForwardRef;